var React = require('react');

function Random (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M9.675 2.077a.727.727 0 0 1 .65 0l7.273 3.636a.727.727 0 0 1 0 1.301l-7.273 3.636a.727.727 0 0 1-.65 0L2.402 7.014a.727.727 0 0 1 0-1.3l7.273-3.637ZM4.354 6.364 10 9.187l5.647-2.823L10 3.54 4.354 6.364Zm-2.277 3.31a.727.727 0 0 1 .976-.324L10 12.823l6.948-3.473a.727.727 0 1 1 .65 1.3l-7.273 3.637a.728.728 0 0 1-.65 0L2.402 10.65a.727.727 0 0 1-.325-.975Zm0 3.637a.727.727 0 0 1 .976-.325L10 16.46l6.948-3.474a.727.727 0 1 1 .65 1.3l-7.273 3.637a.727.727 0 0 1-.65 0l-7.273-3.636a.727.727 0 0 1-.325-.976Z","fill":"#000024"}));
}

Random.defaultProps = {"width":"20","height":"20","viewBox":"0 0 20 20","fill":"none"};

module.exports = Random;

Random.default = Random;
